// Force a real download for cross-origin (S3) files — the plain <a download>
// attribute is ignored cross-origin and the browser opens a new tab instead.
export const downloadFile = async (url, name) => {
  try {
    const res = await fetch(url);
    if (!res.ok) throw new Error(`HTTP ${res.status}`);
    const blob = await res.blob();
    const objectUrl = URL.createObjectURL(blob);
    const a = document.createElement('a');
    a.href = objectUrl;
    a.download = name || 'download';
    document.body.appendChild(a);
    a.click();
    a.remove();
    setTimeout(() => URL.revokeObjectURL(objectUrl), 4000);
  } catch (e) {
    window.open(url, '_blank', 'noopener,noreferrer'); // fallback
  }
};

// Download a chat attachment by message id. Asks the backend for a
// short-lived presigned URL signed with `Content-Disposition: attachment`,
// so S3 tells the browser to save the file instead of opening it in a new
// tab. Falls back to `downloadFile` (blob fetch) if the backend call fails.
export const downloadChatAttachment = async (api, messageId, fallbackUrl, filename) => {
  try {
    const { data } = await api.get(`/chat/messages/${messageId}/download-url`);
    if (data && data.url) {
      const a = document.createElement('a');
      a.href = data.url;
      // `download` is a hint; the real force-download comes from the S3
      // Content-Disposition header attached to the presigned URL.
      a.download = data.filename || filename || 'download';
      a.rel = 'noopener noreferrer';
      document.body.appendChild(a);
      a.click();
      a.remove();
      return;
    }
  } catch (_e) {
    // fall through to the blob-fetch fallback
  }
  if (fallbackUrl) {
    await downloadFile(fallbackUrl, filename);
  }
};
